var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIdentification = function SvgIdentification(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    fill: "currentColor"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M2.5 4.928c0-1.696 1.179-3.261 2.846-3.261h6.946c.165 0 .324.065.442.183L16.9 6.016a.63.63 0 0 1 .183.442v9.03c0 1.696-1.179 3.262-2.846 3.262H5.346c-1.668 0-2.846-1.567-2.846-3.27zm2.846-2.011c-.785 0-1.596.796-1.596 2.01V15.48c0 1.225.813 2.02 1.596 2.02h8.891c.785 0 1.596-.797 1.596-2.011V6.717l-.05-.05h-3.408a.29.29 0 0 1-.292-.292V2.967l-.05-.05z",
    clipRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M7.831 8.689a2.04 2.04 0 1 1 4.078 0 2.04 2.04 0 0 1-4.078 0m2.04-1.228a1.228 1.228 0 1 0 0 2.456 1.228 1.228 0 0 0 0-2.456M8.534 12.362c-.858 0-1.552.694-1.552 1.552v.93a.406.406 0 1 1-.811 0v-.93a2.363 2.363 0 0 1 2.363-2.364h2.932a2.363 2.363 0 0 1 2.363 2.364v.93a.406.406 0 1 1-.81 0v-.93c0-.858-.696-1.553-1.553-1.553z",
    clipRule: "evenodd"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.277,
    d: "M7.831 8.689a2.04 2.04 0 1 1 4.078 0 2.04 2.04 0 0 1-4.078 0m2.04-1.228a1.228 1.228 0 1 0 0 2.456 1.228 1.228 0 0 0 0-2.456M8.534 12.362c-.858 0-1.552.694-1.552 1.552v.93a.406.406 0 1 1-.811 0v-.93a2.363 2.363 0 0 1 2.363-2.364h2.932a2.363 2.363 0 0 1 2.363 2.364v.93a.406.406 0 1 1-.81 0v-.93c0-.858-.696-1.553-1.553-1.553z",
    clipRule: "evenodd"
  })));
};
export default SvgIdentification;